module.exports = __webpack_public_path__ + "img/logo-icon.aee54342.png";